import * as angular from "angular";
import { CAPSULE_MANAGER_GUIDE_COMPONENT, capsuleManagerGuideComponent } from "./capsuleManagerGuide.component";

export default angular
    .module("board.web.admin.capsuleManagerGuide", [])
    .component(CAPSULE_MANAGER_GUIDE_COMPONENT, capsuleManagerGuideComponent)
    .name;


// WEBPACK FOOTER //
// ./app/capsule-manager-guide/capsuleManagerGuide.module.ts